/**
 * Created by Ning Jiang on 3/6/2019.
 */
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {RomanEmpireGameConfig} from "../../RomanEmpireGameConfig";
import {AnimatedParticle, Emitter} from "pixi-particles"
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";

export class RomanEmpireInitialWPView extends BaseView {
    private _coinEmitters: Emitter;
    private _layer:ScalableLayer;
    private _initMaxParticles: number = 50;
    private _coinConfig = {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.5,
            "end": 0.4,
            "minimumScaleMultiplier": 0.5
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 1000,
            "end": 350,
            "minimumSpeedMultiplier": 1.3
        },
        "acceleration": {
            "x": 0,
            "y": 1250
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": -110,
            "max": -70
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": -400,
            "max": 400
        },
        "lifetime": {
            "min": 2.1,
            "max": 2.1
        },
        "blendMode": "normal",
        "frequency": 0.005,
        "emitterLifetime": 0.1,
        "maxParticles": 50,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -100,
            "y": -25,
            "w": 200,
            "h": 50
        }
    };

    constructor() {
        super();
        this._layer = StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);

    }

    protected initAnimations(): void {
        const emitter: Emitter = new Emitter(this._layer, [{
            framerate: 30,
            loop: true,
            hasLoaded: true,
            textures: GameResources.getTextures(`bigWinCoin0`)
        }], this._coinConfig);
        emitter.particleConstructor = AnimatedParticle;
        ParticlesManager.addEmitter(emitter, false);
        this._coinEmitters = emitter;
    }

    public startWinFountain(): void {
        if (this._isResizeDirty) {
            this.onResize(this._resizeData);
        }
        this._coinEmitters.emit = true;
    }

    public stopWinFountain(): void {
        this._coinEmitters.emit = false;
        this._coinEmitters.maxParticles = this._initMaxParticles;
    }


    protected onResize(resizeData: IResizeData): void {
        const y: number = Math.round((resizeData.height - this._layer.y) / this._layer.scale.y) + 40;
        this._coinEmitters.updateOwnerPos(RomanEmpireGameConfig.instance.REEL_AREA_CENTER_X, y);
        this._coinEmitters.startSpeed.value = (resizeData.orientation === Orientation.PORTRAIT) ? 1300 : 900;
        this._coinEmitters.spawnPos.y = -20;
    }
}